import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {
    CreateDish,
    CreateDishImage,
    GetAllAllergens,
    GetAllIngredients,
    GetDietTypes,
    GetDishById,
    UpdateDish,
} from './DishesApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DishSlice = createSlice({
    name: 'dish',
    initialState: {
        dietTypesAll: [],
        allAlergens: [],
        dishById: [],
        allIngredients: [],
        createDish: null,
        updateDish: null,
        dishImage: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetDietTypes.fulfilled, (state, { payload }) => {
                state.dietTypesAll = ResponseApi(payload);
            })
            .addCase(GetAllAllergens.fulfilled, (state, { payload }) => {
                state.allAlergens = ResponseApi(payload);
            })
            .addCase(GetDishById.fulfilled, (state, { payload }) => {
                state.dishById = ResponseApi(payload);
            })
            .addCase(GetAllIngredients.fulfilled, (state, { payload }) => {
                state.allIngredients = ResponseApi(payload);
            })
            .addCase(CreateDish.fulfilled, (state, { payload }) => {
                state.createDish = ResponseApi(payload);
            })
            .addCase(UpdateDish.fulfilled, (state, { payload }) => {
                state.updateDish = ResponseApi(payload);
            })
            .addCase(CreateDishImage.fulfilled, (state, { payload }) => {
                state.dishImage = ResponseApi(payload);
            });
    },
});

export default DishSlice.reducer;
